import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { insuranceType } from "../../store/insuranceType/actions";
export var GetInsurancesTypes = function (trigger, enable, page, limit, clientId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseInsuranceType: (_a = state.InsuranceType.responseInsuranceType) === null || _a === void 0 ? void 0 : _a.data,
            errorInsuranceType: state.InsuranceType.errorInsuranceType,
            loadingInsuranceType: state.InsuranceType.loadingInsuranceType,
        });
    }), responseInsuranceType = _a.responseInsuranceType, errorInsuranceType = _a.errorInsuranceType, loadingInsuranceType = _a.loadingInsuranceType;
    useEffect(function () {
        if (trigger) {
            dispatch(insuranceType({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
    }, [clientId, enable, limit, page, trigger]);
    return {
        responseInsuranceType: responseInsuranceType,
        errorInsuranceType: errorInsuranceType,
        loadingInsuranceType: loadingInsuranceType,
    };
};
